import { axiosConsumer } from "../consumer/axios-consumer";

const resource = '/api/time-report';

const apiFindWeekLoggedUserTimeReports = async (req)=> new Promise((resolve, reject)=> axiosConsumer().post(`${resource}/`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));
const apiCreateNewTimeReport = async (req)=> new Promise((resolve, reject)=> axiosConsumer().put(`${resource}/create`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));
const apiUpdateExisistingTimeReport = async (req)=> new Promise((resolve, reject)=> axiosConsumer().patch(`${resource}/edit`, req)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));
const apiLogicDeleteTimeReportById = async (id)=> new Promise((resolve, reject)=> axiosConsumer().delete(`${resource}/${id}`)
  .then((res)=> resolve(res.data))
  .catch((e)=> reject(e.response.data)));

export const EventRepository = {
  findByWeek: apiFindWeekLoggedUserTimeReports,
  create: apiCreateNewTimeReport,
  update: apiUpdateExisistingTimeReport,
  deleteById: apiLogicDeleteTimeReportById
};
